module.exports = __webpack_public_path__ + "json/market4-0.json?2c2b8fbd0ac0957081c4831d9fed6e70";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market4-0.json
// module id = 1265
// module chunks = 3